export const SHARED = {

  // ------------------------------------------------- NAMESPACE ---------------------------------------------------
  namespace: 'shared',

  // IN MIXIN
  setLanguageCode: 'setLanguageCode',
  getLanguageCode: 'getLanguageCode',

  getTraduction: 'getTraduction',

  setStatusText: 'setStatusText',
  getStatusText: 'getStatusText',

}
